<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre7"><span id="pgepubid00020" title="[Pg 19]"></span></p>
<h2 class="nobreak" id="CHAPTER_III">CHAPTER III<br class="calibre16"/><br class="calibre16"/>
<span class="small">AN EARLY VISIT</span></h2>
</div>
<p class="calibre7"><span class="smcap">Anima</span> ayah pounced upon the gage
thus recklessly flung at her, and was proceeding to pour
out the seven vials of her wrath in a lava-like stream,
when, luckily for her challenger, the sound of hoofs
outside, a spurred heel on the steps, created a diversion.
Then a man's voice called up, "Hullo, Lena, are you at
home?"</p>
<p class="calibre7">Instantly the dirzee seized the half-clad figure in
his arms, and eloped with it indoors, whilst Angel sprang
to the blind, dragged it back, and ushered in Philip
Gascoigne.</p>
<p class="calibre7">"Well, little one," he said, taking her limp hand in
his, "How are you to-day? Lena, please don't move." For
Mrs. Wilkinson had struggled up, and now sat erect on her
long cane lounge, vainly endeavouring to make the end of
her old tea gown cover the toes of her shabby slippers.</p>
<p class="calibre7">"I'm only going to stay five minutes," continued her
visitor, seating himself astride a chair. "How did you
enjoy the children's party?"</p>
<p class="calibre7">"Not much," she answered with a laugh.</p>
<p class="calibre7">"And Angel—not at all, eh?"</p>
<p class="calibre7">"Angel!" cried Mrs. Wilkinson, suddenly raising her
voice, "do stop that horrible machine, and run away and
learn your lessons."</p>
<p class="calibre7"><span id="pgepubid00021" title="[Pg 20]"></span></p>
<p class="calibre7">Angel paused in her labours, drew her beautifully marked
eyebrows together, and looked curiously at her mother. Then
she rose, handed her frill to the dirzee, and obediently
withdrew, vanishing through one of the many doors into the
interior of the bungalow—but not to learn her lessons. Oh
no, she went straight to Mrs. Wilkinson's bedroom, hunted
about for a certain library book, and settled herself
comfortably on a sofa. There, stretched at full length,
with a couple of cushions carefully arranged at her back,
she resembled a small edition of her mother! Presently she
opened the novel, found her place, and began to read. The
name of the novel was "Moths."</p>
<p class="calibre7">In the meanwhile conversation in the verandah was
proceeding; as soon as her daughter had disappeared, Mrs.
Wilkinson resumed:</p>
<p class="calibre7">"I left Angel at home as a punishment; it's only the
punishment she feels."</p>
<p class="calibre7">"She feels a good many things," rejoined Gascoigne.
"What has she been up to now?"</p>
<p class="calibre7">"Oh, never mind," retorted the lady, with a touch of
irritation. "You think Angel <i class="calibre11">is</i> an angel."</p>
<p class="calibre7">"Excuse me, I do not; but she is only a child—we were
children ourselves. Why are you all so rough on her?"</p>
<p class="calibre7">"I'm sure I'm not rough on her," protested Mrs.
Wilkinson in a highly injured key, "but she is always
rubbing Richard up the wrong way—he is so sensitive, too,
and only the other day she called him a 'mud cart officer.'
Really, I can't imagine where she picks up her awful
expressions."</p>
<p class="calibre7">"She picks up everything, I fancy—chaff and corn,"
remarked her cousin.</p>
<p class="calibre7"><span id="pgepubid00022" title="[Pg 21]"></span></p>
<p class="calibre7">"At any rate, Richard simply detests her," continued
Mrs. Wilkinson. "I keep her out of his way as much as
possible, as he hates the very sight of her. He says you
never know what she is going to do next; she plays the most
unexpected tricks, she is heartless, untruthful, and fond
of luxury."</p>
<p class="calibre7">Gascoigne broke into a short, incredulous laugh. "What!
that thin, shabby little child. My dear Lena, she does not
know what the word luxury means."</p>
<p class="calibre7">Her mother heaved a profound sigh as she answered,
"Remember, I do not say these horrid things. I know that
Angel is not heartless; she has strong feelings, she is
devoted to me—and she simply worships <i class="calibre11">you</i>."</p>
<p class="calibre7">"Oh, bosh!" he exclaimed, with a gesture of protest.</p>
<p class="calibre7">"But it is true, I assure you, that in Angel's eyes you
are something between a Fairy Prince and a Holy Saint, and
quite perfect. She actually threw a milk jug at Pinky,
because he said you were ugly."</p>
<p class="calibre7">Gascoigne laughed a hearty laugh, displaying his nice
white teeth. He could well afford to despise Pinky's
opinion, for, although no rival to Beauty Shafto, Gascoigne
was a good-looking fellow, and made a conspicuous and
agreeable figure in that somewhat squalid verandah, with
his trim uniform and well-groomed air. His forehead and
jaw were square, his eyes dark, cool, and penetrating; the
whole expression indicated keen intelligence and absolute
self-control.</p>
<p class="calibre7">Altogether it was an interesting face. A face that had
left its impress on most people's memories.</p>
<p class="calibre7"><span id="pgepubid00023" title="[Pg 22]"></span></p>
<p class="calibre7">"Threw the milk jug," he repeated; "that was scarcely
the retort courteous; but I'm glad to see she made a
bad shot," and he glanced at Pinky's round and stolid
countenance. "What's all this finery for?" he continued,
timidly touching the satin in her lap.</p>
<p class="calibre7">"To make me beautiful," she answered. "Men's garments
are so hideous that women have to do double duty. I am
going to wear this at the Giffards' cotillion to-morrow
night."</p>
<p class="calibre7">"A dance, this weather. What lunacy!"</p>
<p class="calibre7">"It may seem so to you, who never enter a ballroom, but
I must do something to keep myself going, and it's cool
enough as yet, after eleven o'clock. Half-a-dozen waltzes
are a better tonic for me than any amount of quinine."</p>
<p class="calibre7">"Long may you live to say so," he exclaimed, "but
waltzing with the thermometer at 100, I should call the
dance of death. Mind you don't overdo it, Lena mia," and he
looked at her narrowly.</p>
<p class="calibre7">Lena Wilkinson was a delicate woman, thin and worn,
with an insatiable appetite for excitement and amusement.
Her social triumphs and secret labours drew heavily on the
bank of a frail constitution, and no one but herself ever
guessed how often she trembled on the verge of a serious
breakdown.</p>
<p class="calibre7">"I say," resumed Gascoigne, "I came to ask if I may take
Angel for a drive this evening? You have no objection, have
you?" he added, as Mrs. Wilkinson's expression conveyed
blank amazement. "At any rate, it will clear her out of
Wilkinson's path for a couple of hours," he concluded
persuasively.</p>
<p class="calibre7"><span id="pgepubid00024" title="[Pg 23]"></span></p>
<p class="calibre7">"But she will think so much of it, and be so flattered
and cock-a-hoop," protested her mother.</p>
<p class="calibre7">"Lena," and his eyes sparkled angrily, "do you grudge
the poor kid even this little pleasure?"</p>
<p class="calibre7">"No, I don't," hastily relenting, "and I'm horrid. I was
thinking that you never took <i class="calibre11">me</i> out."</p>
<p class="calibre7">"I shall be only too honoured. You have but to name your
own time. I thought you hated a two-wheeled trap, or I'd
have offered long ago."</p>
<p class="calibre7">"It's quite true, I do loathe high dog carts and pulling
trotters. I've no courage now, and that Sally of yours goes
like an express train. Ten years ago, how I should have
loved it! What a curse it is to have nerves!"</p>
<p class="calibre7">"I expect you want a change to the hills. Angel tells me
you are not going to stir this hot weather. Mind you, Lena,
it is a mistake."</p>
<p class="calibre7">"Oh, I know; but Richard declares that he cannot
possibly afford two establishments, and he must stay
down. Angel looks bleached. Three hot seasons are enough
to take the colour out of anyone, and are trying to a
child. That is what makes her so cross, and dainty, and
discontented."</p>
<p class="calibre7">"You ought to go away, Lena, if only for two months. You
look run down yourself."</p>
<p class="calibre7">"Yes, and I feel run down, too." Here she paused, took
up her work for a moment, and put in two or three stitches.
"I sometimes wonder——" she began, and said no more.</p>
<p class="calibre7">"What do you sometimes wonder?" he inquired.</p>
<p class="calibre7">"It is only when I lie awake at night, listening to the
jackals—they always make me feel so desperately

<span id="pgepubid00025" title="[Pg 24]"></span>

depressed, and when I am quite in the blues I cannot help
asking myself what would become of Angel if—anything
happened to me?"</p>
<p class="calibre7">"What a dismal idea, an odious little blue devil!" he
exclaimed. "You should light a lamp and read some cheery
novel; that would soon chase him away."</p>
<p class="calibre7">"And I might fall asleep, and set the bungalow on
fire."</p>
<p class="calibre7">"Look here, Lena," he resumed, hitching his chair a
little closer, "you know I'm pretty well off; no debts, no
wife."</p>
<p class="calibre7">"Fancy naming them in the same breath!" she protested
with a laugh.</p>
<p class="calibre7">"Well, sometimes one brings the other," and he nodded
his head gaily; then, lowering his voice, he continued,
"I daresay it is hard for Wilkinson to make both ends
meet, with heavy insurances, and all that sort of
thing"—Wilkinson was scrupulously saving and investing
half of his pay—"so—so——" Then, with a sudden rush, "If
you'll just run up to the hills for three months, and take
Angel and the boys—I'll make it all right—you know I'm your
cousin."</p>
<p class="calibre7">"Yes," she assented rather bitterly, "and the only
Gascoigne who ever deigned to take the smallest notice of
me; but it can't be done, Phil. You are a dear good fellow
to suggest it, and if the matter lay with me I'd accept it
like a shot and be off to-morrow; but Richard would not
hear of it."</p>
<p class="calibre7">"Well, then, let me send Angel, with an ayah, to some
good boarding-house where the lady will look after her.
Surely, he would make no objection

<span id="pgepubid00026" title="[Pg 25]"></span>

to that. She would be out of his sight for months."</p>
<p class="calibre7">"Perhaps not; but he has such odd ideas, and although he
does not want her here, I doubt if he would allow her to
go elsewhere. There," starting up, "I hear him now. He is
coming."</p>
<p class="calibre7">"At any rate, you might sound him, Lena, and I'll call
in for Angel at half-past five."</p>
<p class="calibre7">"Hullo, Gascoigne—you here?" and a stout, breathless
little man, with prodigious moustache and a shining round
face, came puffing up the steps. "I tell you," he panted,
"this day is going to be a corker!—my reins were mad hot,
and Graham says there are five cases of heat apoplexy in
hospital. Lena, we must have the cuscus tatties up at
once."</p>
<p class="calibre7">"They say this season is to be something quite extra,"
remarked Gascoigne, who had risen to his feet.</p>
<p class="calibre7">"Yes, yes," cried Colonel Wilkinson, "the usual bazaar
talk. But," mopping his face, "if this is the beginning,
where shall we all be in the end of May—eh, Lena?"</p>
<p class="calibre7">"In the cemetery, perhaps," she suggested gravely.</p>
<p class="calibre7">"Come, come, old woman—none of your ghastly jokes.
Hullo, Beany boy; well, my Pinkums. Ayah," in a sharper
key, "what do you mean by letting Master Beany wear his
best shoes?"</p>
<p class="calibre7">"They are all he has got, sahib—others done fall to
pieces," she answered sullenly.</p>
<p class="calibre7">"Fall to grandmother! Let <i class="calibre11">me</i> see them. And I
say, the children are to have plenty of ice in their milk
to-day. I've ordered in two seers extra. Has Master Baba
had his tonic? Here—you must all

<span id="pgepubid00027" title="[Pg 26]"></span>

clear out of the verandah—it's like a furnace. Away you
go!" and, raising his arms as if driving a flock of geese,
he hustled the whole family precipitately indoors, whilst
Gascoigne snatched up his whip and fled.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?569ac87c